// import React, { useState, useEffect, useCallback } from 'react';
// import QRCode from 'qrcode';

// // ─── CONFIG ──────────────────────────────────────────────────────────────────
// const API_BASE     = 'https://localhost:7095/api/Qr';
// const LIVE_BASE_URL = 'https://qrorder.selfos.in/';

// // ─── HELPERS ─────────────────────────────────────────────────────────────────
// // const buildQrUrl = (tableId, storeId, companyId) =>
  
// //   `${LIVE_BASE_URL}?table=${tableId}&storeId=${storeId}&companyId=${companyId}`;
// const buildQrUrl = (tableId, storeId, companyId) => {
//   const token = btoa(`${tableId}|${storeId}|${companyId}`);
//   return `${LIVE_BASE_URL}?q=${encodeURIComponent(token)}`;
// };
// // const generateQRDataUrl = (url) =>
// //   QRCode.toDataURL(url, { width: 320, margin: 2, errorCorrectionLevel: 'H',
// //     color: { dark: '#1a1a2e', light: '#ffffff' } });
// const generateQRDataUrl = async (url, companyId, logoSrc = '/assets/Kadherbhai_logo.jpeg') => {
//   const qrSize = 320;
//   const scale = 3; // render at 3x then keep this resolution in the PNG — crisper logo
//   const renderSize = qrSize * scale;

//   const canvas = document.createElement('canvas');
//   await QRCode.toCanvas(canvas, url, {
//     width: renderSize,
//     margin: 2,
//     errorCorrectionLevel: 'H',
//     color: { dark: '#1a1a2e', light: '#ffffff' },
//   });

//   if (Number(companyId) !== 5) {
//     return canvas.toDataURL('image/png');
//   }

//   const ctx = canvas.getContext('2d');
//   ctx.imageSmoothingEnabled = true;
//   ctx.imageSmoothingQuality = 'high';

//   const logo = await new Promise((resolve, reject) => {
//     const img = new Image();
//     img.crossOrigin = 'anonymous';
//     img.onload = () => resolve(img);
//     img.onerror = reject;
//     img.src = logoSrc;
//   });

//   const logoSizeRatio = 0.24;
//   const logoSize = renderSize * logoSizeRatio;
//   const logoX = (renderSize - logoSize) / 2;
//   const logoY = (renderSize - logoSize) / 2;

//   const ringPadding = 3 * scale;
//   const bgSize = logoSize + ringPadding * 2;
//   const bgRadius = bgSize / 2;
//   const cx = renderSize / 2;
//   const cy = renderSize / 2;

//   ctx.save();
//   ctx.shadowColor = 'rgba(0,0,0,0.18)';
//   ctx.shadowBlur = 6 * scale;
//   ctx.fillStyle = '#ffffff';
//   ctx.beginPath();
//   ctx.arc(cx, cy, bgRadius, 0, Math.PI * 2);
//   ctx.fill();
//   ctx.restore();

//   ctx.strokeStyle = '#c8102e';
//   ctx.lineWidth = 2 * scale;
//   ctx.beginPath();
//   ctx.arc(cx, cy, bgRadius, 0, Math.PI * 2);
//   ctx.stroke();

//   ctx.save();
//   ctx.beginPath();
//   ctx.arc(cx, cy, logoSize / 2, 0, Math.PI * 2);
//   ctx.clip();

//   const drawScale = Math.max(logoSize / logo.width, logoSize / logo.height);
//   const drawW = logo.width * drawScale;
//   const drawH = logo.height * drawScale;
//   const drawX = logoX + (logoSize - drawW) / 2;
//   const drawY = logoY + (logoSize - drawH) / 2;
//   ctx.drawImage(logo, drawX, drawY, drawW, drawH);
//   ctx.restore();

//   return canvas.toDataURL('image/png');
// };
// // ─── MAIN COMPONENT ──────────────────────────────────────────────────────────
// export default function QRCodeAdmin() {
//   // Hierarchy data
//   const [companies,  setCompanies]  = useState([]);
//   const [stores,     setStores]     = useState([]);
//   const [areas,      setAreas]      = useState([]);
//   const [tables,     setTables]     = useState([]);
//   const [qrImages,   setQrImages]   = useState({});      // { tableId: dataUrl }

//   // Selections
//   const [selCompany, setSelCompany] = useState('');
//   const [selStore,   setSelStore]   = useState('');
//   const [selArea,    setSelArea]    = useState('all');   // 'all' or areaId

//   // UI state
//   const [loadingTables, setLoadingTables] = useState(false);
//   const [showModal,     setShowModal]     = useState(false);
//   const [saving,        setSaving]        = useState(false);
//   const [toast,         setToast]         = useState(null);   // { type, msg }
// const [printTarget, setPrintTarget] = useState(null); // null = print all, or a table object
//   // Edit form
//   const [editData, setEditData] = useState({
//     sosDineTableId: null,
//     diningTableId: 0,
//     storeId: 0,
//     companyId: 0,
//     tableName: '',
//     latitude: '',
//     longitude: '',
//     allowedRadius: 50,
//     isActive: true,
//   });

//   // ── Toaster ────────────────────────────────────────────────────────────────
//   const showToast = (msg, type = 'success') => {
//     setToast({ msg, type });
//     setTimeout(() => setToast(null), 3500);
//   };

//   // ── 1. Load companies ──────────────────────────────────────────────────────
//   useEffect(() => {
//     fetch(`${API_BASE}/GetCompanies`)
//       .then(r => r.json())
//       .then(d => setCompanies(d.companies || []))
//       .catch(() => showToast('Failed to load companies', 'error'));
//   }, []);

//   // ── 2. Load stores when company changes ────────────────────────────────────
//   useEffect(() => {
//     setStores([]); setSelStore(''); setAreas([]); setSelArea('all'); setTables([]); setQrImages({});
//     if (!selCompany) return;
//     fetch(`${API_BASE}/GetStoresByCompany?companyId=${selCompany}`)
//       .then(r => r.json())
//       .then(d => setStores(d.stores || []))
//       .catch(() => showToast('Failed to load stores', 'error'));
//   }, [selCompany]);

//   // ── 3. Load areas when store changes ───────────────────────────────────────
//   useEffect(() => {
//     setAreas([]); setSelArea('all'); setTables([]); setQrImages({});
//     if (!selStore) return;
//     fetch(`${API_BASE}/GetDiningAreasByStore?storeId=${selStore}`)
//       .then(r => r.json())
//       .then(d => setAreas(d.areas || []))
//       .catch(() => showToast('Failed to load floors', 'error'));
//   }, [selStore]);
// const printSingle = (table) => {
//   setPrintTarget(table);
//   // wait a tick so React updates the print-only DOM before printing
//   setTimeout(() => {
//     window.print();
//   }, 50);
// };
// const printAllTables = () => {
//   setPrintTarget(null);
//   setTimeout(() => {
//     window.print();
//   }, 50);
// };
//   // ── 4. Load tables when area/store changes ─────────────────────────────────
//   const fetchTables = useCallback(async () => {
//     if (!selStore) return;
//     setLoadingTables(true);
//     setQrImages({});
//     try {
//       const url = selArea === 'all'
//         ? `${API_BASE}/GetAllTablesByStore?storeId=${selStore}`
//         : `${API_BASE}/GetDiningTablesByArea?areaId=${selArea}`;
//       const res  = await fetch(url);
//       const data = await res.json();
//       const tbls = data.tables || [];
//       setTables(tbls);

//       // Generate QR codes in parallel
//       const imgs = {};
//       await Promise.all(tbls.map(async t => {
//         const qrUrl = buildQrUrl(t.id, t.storeId, t.companyId);
//         imgs[t.id] = await generateQRDataUrl(qrUrl,t.companyId);
//       }));
//       setQrImages(imgs);
//     } catch {
//       showToast('Failed to load tables', 'error');
//     }
//     setLoadingTables(false);
//   }, [selStore, selArea]);

//   useEffect(() => { fetchTables(); }, [fetchTables]);

//   // ── Open edit modal ─────────────────────────────────────────────────────────
//   const openEdit = (table) => {
//     setEditData({
//       sosDineTableId: table.sosDineTableId ?? null,
//       diningTableId:  table.id,
//       storeId:        table.storeId,
//       companyId:      table.companyId,
//       tableName:      table.tableName,
//       latitude:       table.latitude  ?? '',
//       longitude:      table.longitude ?? '',
//       allowedRadius:  table.allowedRadius ?? 50,
//       isActive:       table.sosIsActive  !== null ? table.sosIsActive : true,
//     });
//     setShowModal(true);
//   };

//   // ── Save SosDineTable ───────────────────────────────────────────────────────
//   const handleSave = async () => {
//     if (editData.latitude === '' || editData.longitude === '') {
//       showToast('Latitude and Longitude are required', 'error');
//       return;
//     }
//     setSaving(true);
//     try {
//          const qrUrl = buildQrUrl(
//       editData.diningTableId,
//       editData.storeId,
//       editData.companyId
//     );
//       const payload = {
//         ...editData,
//          qrCodeUrl: qrUrl,
//         latitude:      parseFloat(editData.latitude),
//         longitude:     parseFloat(editData.longitude),
//         allowedRadius: parseFloat(editData.allowedRadius),
//       };
//       const res  = await fetch(`${API_BASE}/SaveSosDineTable`, {
//         method:  'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body:    JSON.stringify(payload),
//       });
//       const data = await res.json();
//       if (data.status === 200) {
//         showToast('Table configuration saved!');
//         setShowModal(false);
//         fetchTables();
//       } else {
//         showToast(data.msg || 'Save failed', 'error');
//       }
//     } catch {
//       showToast('Network error', 'error');
//     }
//     setSaving(false);
//   };

//   // ── Toggle active status ────────────────────────────────────────────────────
//   const toggleStatus = async (sosDineTableId, current) => {
//     try {
//       const res  = await fetch(`${API_BASE}/UpdateSosDineTableStatus`, {
//         method:  'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body:    JSON.stringify({ id: sosDineTableId, isActive: !current }),
//       });
//       const data = await res.json();
//       if (data.status === 200) {
//         showToast('Status updated');
//         fetchTables();
//       }
//     } catch {
//       showToast('Failed to update status', 'error');
//     }
//   };

//   // ── Download single QR ──────────────────────────────────────────────────────
//   const downloadQR = (tableId, tableName) => {
//     const link = document.createElement('a');
//     link.download = `QR_${tableName || tableId}.png`;
//     link.href = qrImages[tableId];
//     link.click();
//   };

//   // ── Download all QRs ────────────────────────────────────────────────────────
//   const downloadAll = async () => {
//     for (const t of tables) {
//       await new Promise(r => setTimeout(r, 400));
//       downloadQR(t.id, t.tableName);
//     }
//   };

//   // ─── Group tables by floor for display ──────────────────────────────────────
//   const groupedTables = tables.reduce((acc, t) => {
//     const key = t.floorName || 'Unassigned';
//     if (!acc[key]) acc[key] = [];
//     acc[key].push(t);
//     return acc;
//   }, {});

//   const selCompanyObj = companies.find(c => c.id === +selCompany);
//   const selStoreObj   = stores.find(s   => s.id === +selStore);

//   // ─────────────────────────────────────────────────────────────────────────────
//   // RENDER
//   // ─────────────────────────────────────────────────────────────────────────────
//   return (
//     <div style={css.root}>
//       {/* ── Inject styles ── */}
//       <style>{globalCss}</style>

//       {/* ── Toast ── */}
//       {toast && (
//         <div style={{ ...css.toast, ...(toast.type === 'error' ? css.toastError : css.toastSuccess) }}>
//           {toast.type === 'success' ? '✓' : '✕'} {toast.msg}
//         </div>
//       )}

//       {/* ══════════════════════════════════════════════════════════════
//           HEADER
//       ═══════════════════════════════════════════════════════════════*/}
//       <header style={css.header} className="qr-header">
//         <div style={css.headerInner} className="qr-header-inner">
//           <div style={css.logo}>
//             <span style={css.logoIcon}>⬡</span>
//             <span style={css.logoText}>QR Admin</span>
//           </div>
//           <div style={css.headerRight} className="qr-header-right">
//             {selCompanyObj && <span style={css.breadCrumb}>{selCompanyObj.name}</span>}
//             {selStoreObj   && <><span style={css.breadSep}>›</span><span style={css.breadCrumb}>{selStoreObj.name}</span></>}
//             {tables.length > 0 && (
//               <div style={css.headerActions} className="qr-header-actions">
//                <button onClick={printAllTables} style={css.btnOutline}>🖨 Print All</button>
//                 <button onClick={downloadAll}           style={css.btnPrimary}>⬇ Download All</button>
//               </div>
//             )}
//           </div>
//         </div>
//       </header>

//       {/* ══════════════════════════════════════════════════════════════
//           FILTER BAR
//       ═══════════════════════════════════════════════════════════════*/}
//       <div style={css.filterBar} className="qr-filter-bar">
//         {/* Company */}
//         <div style={css.filterGroup} className="qr-filter-group">
//           <label style={css.filterLabel}>Company</label>
//           <select style={css.select} className="qr-select" value={selCompany}
//             onChange={e => setSelCompany(e.target.value)}>
//             <option value=''>— Select Company —</option>
//             {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
//           </select>
//         </div>

//         {/* Store */}
//         <div style={css.filterGroup} className="qr-filter-group">
//           <label style={css.filterLabel}>Store</label>
//           <select style={css.select} className="qr-select" value={selStore}
//             onChange={e => setSelStore(e.target.value)} disabled={!selCompany}>
//             <option value=''>— Select Store —</option>
//             {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
//           </select>
//         </div>

//         {/* Floor / Area */}
//         <div style={css.filterGroup} className="qr-filter-group">
//           <label style={css.filterLabel}>Floor / Area</label>
//           <select style={css.select} className="qr-select" value={selArea}
//             onChange={e => setSelArea(e.target.value)} disabled={!selStore}>
//             <option value='all'>— All Floors —</option>
//             {areas.map(a => <option key={a.id} value={a.id}>{a.description}</option>)}
//           </select>
//         </div>

//         {/* Stats pill */}
//         {tables.length > 0 && (
//           <div style={css.statsPill} className="qr-stats-pill">
//             <span style={css.statsNum}>{tables.length}</span>
//             <span style={css.statsLabel}>Tables</span>
//           </div>
//         )}
//       </div>

//       {/* ══════════════════════════════════════════════════════════════
//           EMPTY STATE
//       ═══════════════════════════════════════════════════════════════*/}
//       {!selStore && (
//         <div style={css.emptyState}>
//           <div style={css.emptyIcon}>📋</div>
//           <div style={css.emptyTitle}>Select a Company and Store</div>
//           <div style={css.emptyDesc}>Choose from the filters above to generate and manage QR codes for your dining tables.</div>
//         </div>
//       )}

//       {/* ══════════════════════════════════════════════════════════════
//           LOADING SPINNER
//       ═══════════════════════════════════════════════════════════════*/}
//       {loadingTables && (
//         <div style={css.loadingWrap}>
//           <div className='qr-spinner'></div>
//           <p style={css.loadingText}>Generating QR Codes…</p>
//         </div>
//       )}

//       {/* ══════════════════════════════════════════════════════════════
//           TABLE GRID  (grouped by floor)
//       ═══════════════════════════════════════════════════════════════*/}
//       {!loadingTables && tables.length > 0 && (
//         <main style={css.main} className="qr-main">
//           {Object.entries(groupedTables).map(([floorName, floorTables]) => (
//             <section key={floorName} style={css.floorSection}>
//               {/* Floor heading */}
//               <div style={css.floorHeading}>
//                 <span style={css.floorIcon}>▤</span>
//                 <span style={css.floorName}>{floorName}</span>
//                 <span style={css.floorCount}>{floorTables.length} table{floorTables.length !== 1 ? 's' : ''}</span>
//               </div>

//               {/* Cards */}
//               <div style={css.cardGrid} className="qr-card-grid">
//                 {floorTables.map(table => {
//                   const isConfigured = table.sosDineTableId !== null;
//                   const qrUrl        = buildQrUrl(table.id, table.storeId, table.companyId);

//                   return (
//                     <div key={table.id}
//                       style={{ ...css.card, ...(isConfigured ? {} : css.cardUnconfigured) }}
//                       className='qr-card'>

//                       {/* Status badge */}
//                       <div style={css.cardBadges}>
//                         {isConfigured
//                           ? <span style={{ ...css.badge, ...(table.sosIsActive ? css.badgeGreen : css.badgeGray) }}>
//                               {table.sosIsActive ? '● Active' : '○ Inactive'}
//                             </span>
//                           : <span style={{ ...css.badge, ...css.badgeOrange }}>⚠ Not Configured</span>
//                         }
//                         {table.scanCount > 0 &&
//                           <span style={{ ...css.badge, ...css.badgeBlue }}>👁 {table.scanCount} scans</span>
//                         }
//                       </div>

//                       {/* Table name */}
//                       <div style={css.tableName}>{table.tableName || `Table ${table.id}`}</div>
//                       <div style={css.tableFloor}>{floorName} · ID #{table.id}</div>

//                       {/* QR Code image */}
//                       <div style={css.qrWrap} className="qr-wrap">
//                         {qrImages[table.id]
//                           ? <img src={qrImages[table.id]} alt={`QR for ${table.tableName}`} style={css.qrImg} className="qr-img"/>
//                           : <div style={css.qrPlaceholder}>Generating…</div>
//                         }
//                       </div>

//                       {/* URL */}
//                       {/* <div style={css.qrUrlText}>{qrUrl}</div> */}

//                       {/* Geo info */}
//                       {isConfigured && (
//                         <div style={css.geoRow}>
//                           <GeoChip label='Lat'    value={table.latitude?.toFixed(5)} />
//                           <GeoChip label='Lng'    value={table.longitude?.toFixed(5)} />
//                           <GeoChip label='Radius' value={`${table.allowedRadius}m`} />
//                         </div>
//                       )}

//                       {/* Actions */}
//                       <div style={css.cardActions} className="qr-card-actions">
//                         <button style={css.btnConfig} onClick={() => openEdit(table)}>
//                           {isConfigured ? '⚙ Edit Config' : '+ Configure'}
//                         </button>
//                         {qrImages[table.id] &&
//                           <button style={css.btnDownload}
//                             onClick={() => downloadQR(table.id, table.tableName)}>
//                             ⬇
//                           </button>
//                         }
//                         {qrImages[table.id] &&
//     <button style={css.btnPrint}
//       onClick={() => printSingle(table)}
//       title='Print only this QR code'>
//       🖨
//     </button>
//   }
//                         {isConfigured &&
//                           <button
//                             style={{ ...css.btnToggle, ...(table.sosIsActive ? css.btnToggleOff : css.btnToggleOn) }}
//                             onClick={() => toggleStatus(table.sosDineTableId, table.sosIsActive)}>
//                             {table.sosIsActive ? '⏸' : '▶'}
//                           </button>
//                         }
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </section>
//           ))}
//         </main>
//       )}

//       {/* ══════════════════════════════════════════════════════════════
//           NO TABLES FOUND
//       ═══════════════════════════════════════════════════════════════*/}
//       {!loadingTables && selStore && tables.length === 0 && (
//         <div style={css.emptyState}>
//           <div style={css.emptyIcon}>🪑</div>
//           <div style={css.emptyTitle}>No Tables Found</div>
//           <div style={css.emptyDesc}>No dining tables are configured for the selected store/floor.</div>
//         </div>
//       )}

//       {/* ══════════════════════════════════════════════════════════════
//           EDIT / CONFIG MODAL
//       ═══════════════════════════════════════════════════════════════*/}
//       {showModal && (
//         <div style={css.overlay} className="qr-overlay" onClick={e => e.target === e.currentTarget && setShowModal(false)}>
//           <div style={css.modal} className="qr-modal qr-modal-box">
//             {/* Modal header */}
//             <div style={css.modalHeader}>
//               <div>
//                 <div style={css.modalTitle}>Configure Table</div>
//                 <div style={css.modalSub}>{editData.tableName} · ID #{editData.diningTableId}</div>
//               </div>
//               <button style={css.modalClose} onClick={() => setShowModal(false)}>✕</button>
//             </div>

//             {/* QR preview in modal */}
//             {qrImages[editData.diningTableId] && (
//               <div style={css.modalQrWrap} className="qr-modal-qr-wrap">
//                 <img src={qrImages[editData.diningTableId]}
//                   alt='QR Preview' style={css.modalQrImg} />
//                 <div style={css.modalQrUrl}>
//                   {buildQrUrl(editData.diningTableId, editData.storeId, editData.companyId)}
//                 </div>
//               </div>
//             )}

//             {/* Form */}
//             <div style={css.formGrid} className="qr-form-grid">
//               <div style={css.formGroup}>
//                 <label style={css.label}>Latitude <span style={css.required}>*</span></label>
//                 <input
//                   style={css.input}
//                   type='number'
//                   step='any'
//                   placeholder='e.g. 10.84380'
//                   value={editData.latitude}
//                   onChange={e => setEditData(p => ({ ...p, latitude: e.target.value }))}
//                 />
//                 <span style={css.hint}>GPS latitude of the table location</span>
//               </div>

//               <div style={css.formGroup}>
//                 <label style={css.label}>Longitude <span style={css.required}>*</span></label>
//                 <input
//                   style={css.input}
//                   type='number'
//                   step='any'
//                   placeholder='e.g. 78.68680'
//                   value={editData.longitude}
//                   onChange={e => setEditData(p => ({ ...p, longitude: e.target.value }))}
//                 />
//                 <span style={css.hint}>GPS longitude of the table location</span>
//               </div>

//               <div style={css.formGroup}>
//                 <label style={css.label}>Allowed Radius (metres)</label>
//                 <input
//                   style={css.input}
//                   type='number'
//                   min='1'
//                   max='500'
//                   value={editData.allowedRadius}
//                   onChange={e => setEditData(p => ({ ...p, allowedRadius: e.target.value }))}
//                 />
//                 <span style={css.hint}>Max distance customer can be from table to scan QR</span>
//               </div>

//               <div style={css.formGroup}>
//                 <label style={css.label}>Status</label>
//                 <div style={css.toggleRow}>
//                   <label style={css.toggleLabel}>
//                     <input
//                       type='checkbox'
//                       checked={editData.isActive}
//                       onChange={e => setEditData(p => ({ ...p, isActive: e.target.checked }))}
//                       style={{ display: 'none' }}
//                     />
//                     <div style={{ ...css.toggle, ...(editData.isActive ? css.toggleOn : css.toggleOff) }}>
//                       <div style={{ ...css.toggleKnob, ...(editData.isActive ? css.toggleKnobOn : {}) }} />
//                     </div>
//                     <span style={css.toggleText}>{editData.isActive ? 'Active' : 'Inactive'}</span>
//                   </label>
//                 </div>
//               </div>
//             </div>

//             {/* Tip box */}
//             <div style={css.tipBox}>
//               💡 <strong>How to get coordinates:</strong> Open Google Maps, right-click your table location, and copy the latitude/longitude values shown.
//             </div>

//             {/* Modal footer */}
//             <div style={css.modalFooter} className="qr-modal-footer">
//               <button style={css.btnCancel} onClick={() => setShowModal(false)}>Cancel</button>
//               <button style={{ ...css.btnSave, ...(saving ? css.btnDisabled : {}) }}
//                 onClick={handleSave} disabled={saving}>
//                 {saving ? 'Saving…' : 'Save Configuration'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══════════════════════════════════════════════════════════════
//           PRINT-ONLY LAYOUT
//       ═══════════════════════════════════════════════════════════════*/}
//    <div className='print-only'>
//   {!printTarget && (
//     <div className='print-header'>
//       <h1>Table QR Codes</h1>
//       {selCompanyObj && <p>Company: {selCompanyObj.name}</p>}
//       {selStoreObj   && <p>Store: {selStoreObj.name}</p>}
//     </div>
//   )}
//   <div className={printTarget ? 'print-grid-single' : 'print-grid'}>
//     {(printTarget ? [printTarget] : tables).map(t => (
//       <div key={t.id} className={printTarget ? 'print-card-single' : 'print-card'}>
//         {!printTarget && (
//           <>
//             <div className='print-floor'>{t.floorName || 'Floor'}</div>
//             <div className='print-table'>{t.tableName || `Table ${t.id}`}</div>
//           </>
//         )}
//         {qrImages[t.id]
//           ? <img
//               src={qrImages[t.id]}
//               alt={`QR ${t.tableName}`}
//               className={printTarget ? 'print-qr-single' : 'print-qr'}
//             />
//           : <div style={{ width: 160, height: 160, margin: '0 auto',
//               display: 'flex', alignItems: 'center', justifyContent: 'center',
//               fontSize: 12, color: '#999' }}>
//               No QR
//             </div>
//         }
//       </div>
//     ))}
//   </div>
// </div>
//     </div>
//   );
// }

// // ─── Small helper component ───────────────────────────────────────────────────
// function GeoChip({ label, value }) {
//   return (
//     <div style={geoChipStyle}>
//       <span style={{ fontSize: 9, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1 }}>{label}</span>
//       <span style={{ fontSize: 11, color: '#1e293b', fontWeight: 600, fontFamily: 'monospace' }}>{value ?? '—'}</span>
//     </div>
//   );
// }
// const geoChipStyle = {
//   background: '#f1f5f9', borderRadius: 6, padding: '3px 7px',
//   display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1,
// };

// // ─── STYLES ───────────────────────────────────────────────────────────────────
// const css = {
//   root: {
//     fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
//     minHeight: '100vh',
//     background: '#f0f4f8',
//     color: '#1e293b',
//   },
//   // Header
//   header: {
//     background: '#0f172a',
//     borderBottom: '1px solid #1e293b',
//     padding: '0 24px',
//     height: 60,
//     display: 'flex',
//     alignItems: 'center',
//   },
//   headerInner: {
//     maxWidth: 1400, width: '100%', margin: '0 auto',
//     display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//   },
//   logo: { display: 'flex', alignItems: 'center', gap: 10 },
//   logoIcon: { fontSize: 22, color: '#f59e0b' },
//   logoText: { fontSize: 18, fontWeight: 700, color: '#f8fafc', letterSpacing: '-0.5px' },
//   headerRight: { display: 'flex', alignItems: 'center', gap: 10 },
//   breadCrumb: { fontSize: 13, color: '#94a3b8' },
//   breadSep: { fontSize: 13, color: '#475569', margin: '0 4px' },
//   headerActions: { display: 'flex', gap: 8, marginLeft: 16 },

//   // Filter bar
//   filterBar: {
//     background: '#fff',
//     borderBottom: '1px solid #e2e8f0',
//     padding: '14px 24px',
//     display: 'flex',
//     alignItems: 'flex-end',
//     gap: 16,
//     flexWrap: 'wrap',
//   },
//   filterGroup: { display: 'flex', flexDirection: 'column', gap: 4, minWidth: 200 },
//   filterLabel: { fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.8px' },
//   select: {
//     padding: '8px 12px', borderRadius: 8,
//     border: '1.5px solid #e2e8f0',
//     fontSize: 14, color: '#1e293b',
//     background: '#fff',
//     cursor: 'pointer',
//     outline: 'none',
//     minWidth: 200,
//   },
//   statsPill: {
//     background: '#0f172a', borderRadius: 10,
//     padding: '6px 14px', display: 'flex',
//     alignItems: 'center', gap: 6,
//     marginLeft: 'auto',
//   },
//   statsNum: { fontSize: 20, fontWeight: 700, color: '#f59e0b' },
//   statsLabel: { fontSize: 12, color: '#94a3b8' },

//   // Buttons
//   btnPrimary: {
//     background: '#f59e0b', color: '#fff', border: 'none',
//     padding: '8px 16px', borderRadius: 8, fontSize: 13,
//     fontWeight: 600, cursor: 'pointer',
//   },
//   btnOutline: {
//     background: 'transparent', color: '#94a3b8',
//     border: '1.5px solid #334155',
//     padding: '7px 16px', borderRadius: 8, fontSize: 13,
//     fontWeight: 600, cursor: 'pointer',
//   },

//   // Empty / loading
//   emptyState: {
//     textAlign: 'center', padding: '80px 24px',
//     maxWidth: 400, margin: '0 auto',
//   },
//   emptyIcon: { fontSize: 48, marginBottom: 16 },
//   emptyTitle: { fontSize: 20, fontWeight: 700, marginBottom: 8, color: '#1e293b' },
//   emptyDesc: { fontSize: 14, color: '#64748b', lineHeight: 1.6 },
//   loadingWrap: {
//     display: 'flex', flexDirection: 'column',
//     alignItems: 'center', padding: '80px 24px',
//   },
//   loadingText: { marginTop: 16, fontSize: 14, color: '#64748b' },

//   // Main / floor sections
//   main: { maxWidth: 1400, margin: '0 auto', padding: '24px' },
//   floorSection: { marginBottom: 36 },
//   floorHeading: {
//     display: 'flex', alignItems: 'center', gap: 10,
//     marginBottom: 16,
//   },
//   floorIcon: { fontSize: 18, color: '#64748b' },
//   floorName: { fontSize: 17, fontWeight: 700, color: '#0f172a' },
//   floorCount: {
//     fontSize: 12, color: '#94a3b8',
//     background: '#f1f5f9', padding: '2px 8px',
//     borderRadius: 20, marginLeft: 4,
//   },

//   // Card grid
//   cardGrid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
//     gap: 20,
//   },
//   card: {
//     background: '#fff',
//     borderRadius: 16,
//     padding: '20px',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.07), 0 4px 12px rgba(0,0,0,0.04)',
//     border: '1.5px solid #e2e8f0',
//     display: 'flex', flexDirection: 'column', gap: 10,
//     transition: 'box-shadow 0.2s, transform 0.2s',
//   },
//   cardUnconfigured: {
//     border: '1.5px dashed #fbbf24',
//     background: '#fffbeb',
//   },

//   // Badges
//   cardBadges: { display: 'flex', gap: 6, flexWrap: 'wrap' },
//   badge: {
//     fontSize: 10, fontWeight: 600, padding: '2px 8px',
//     borderRadius: 20, letterSpacing: '0.3px',
//   },
//   badgeGreen:  { background: '#dcfce7', color: '#166534' },
//   badgeGray:   { background: '#f1f5f9', color: '#64748b' },
//   badgeOrange: { background: '#fef3c7', color: '#92400e' },
//   badgeBlue:   { background: '#dbeafe', color: '#1e40af' },

//   tableName: { fontSize: 16, fontWeight: 700, color: '#0f172a' },
//   tableFloor: { fontSize: 12, color: '#94a3b8', marginTop: -6 },

//   qrWrap: {
//     display: 'flex', justifyContent: 'center',
//     background: '#f8fafc', borderRadius: 10, padding: 12,
//   },
//   qrImg: { width: 160, height: 160, borderRadius: 6 },
//   qrPlaceholder: {
//     width: 160, height: 160, display: 'flex',
//     alignItems: 'center', justifyContent: 'center',
//     fontSize: 12, color: '#94a3b8',
//   },
//   qrUrlText: {
//     fontSize: 9, color: '#94a3b8', wordBreak: 'break-all',
//     background: '#f8fafc', padding: '5px 8px', borderRadius: 6,
//     fontFamily: 'monospace', lineHeight: 1.5,
//   },
//   geoRow: {
//     display: 'flex', gap: 6, flexWrap: 'wrap',
//   },

//   cardActions: { display: 'flex', gap: 8, marginTop: 4 },
//   btnConfig: {
//     flex: 1, background: '#0f172a', color: '#fff',
//     border: 'none', borderRadius: 8, padding: '8px 12px',
//     fontSize: 12, fontWeight: 600, cursor: 'pointer',
//   },
// btnDownload: {
//   background: '#f1f5f9', border: 'none', borderRadius: 8,
//   padding: '8px 10px', fontSize: 14, cursor: 'pointer',
// },

//   btnToggle: {
//     border: 'none', borderRadius: 8,
//     padding: '8px 10px', fontSize: 14, cursor: 'pointer',
//   },
//   btnToggleOff: { background: '#fee2e2', color: '#dc2626' },
//   btnToggleOn:  { background: '#dcfce7', color: '#16a34a' },

//   // Modal
//   overlay: {
//     position: 'fixed', inset: 0,
//     background: 'rgba(0,0,0,0.55)',
//     backdropFilter: 'blur(4px)',
//     zIndex: 1000,
//     display: 'flex', alignItems: 'center', justifyContent: 'center',
//     padding: 16,
//   },
//   modal: {
//     background: '#fff', borderRadius: 20,
//     width: '100%', maxWidth: 540,
//     maxHeight: '90vh', overflowY: 'auto',
//     padding: 28,
//     boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
//     display: 'flex', flexDirection: 'column', gap: 20,
//   },
//   modalHeader: {
//     display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
//   },
//   modalTitle: { fontSize: 18, fontWeight: 700, color: '#0f172a' },
//   modalSub: { fontSize: 13, color: '#64748b', marginTop: 2 },
//   modalClose: {
//     background: '#f1f5f9', border: 'none', borderRadius: 8,
//     width: 32, height: 32, cursor: 'pointer', fontSize: 14,
//   },

//   modalQrWrap: {
//     background: '#f8fafc', borderRadius: 12, padding: 16,
//     display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8,
//   },
//   modalQrImg: { width: 140, height: 140, borderRadius: 8 },
//   modalQrUrl: {
//     fontSize: 9, color: '#94a3b8', wordBreak: 'break-all',
//     textAlign: 'center', fontFamily: 'monospace',
//   },

//   formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 },
//   formGroup: { display: 'flex', flexDirection: 'column', gap: 4 },
//   label: { fontSize: 12, fontWeight: 600, color: '#374151' },
//   required: { color: '#ef4444' },
//   input: {
//     padding: '9px 12px', borderRadius: 8,
//     border: '1.5px solid #e2e8f0',
//     fontSize: 14, color: '#1e293b',
//     outline: 'none',
//   },
//   hint: { fontSize: 11, color: '#94a3b8', lineHeight: 1.4 },

//   toggleRow: { display: 'flex', alignItems: 'center', paddingTop: 4 },
//   toggleLabel: { display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' },
//   toggle: {
//     width: 44, height: 24, borderRadius: 12,
//     position: 'relative', transition: 'background 0.2s',
//   },
//   toggleOn:  { background: '#22c55e' },
//   toggleOff: { background: '#cbd5e1' },
//   toggleKnob: {
//     position: 'absolute', top: 2, left: 2,
//     width: 20, height: 20, borderRadius: '50%',
//     background: '#fff', transition: 'transform 0.2s',
//     boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
//   },
//   toggleKnobOn: { transform: 'translateX(20px)' },
//   toggleText: { fontSize: 13, fontWeight: 600, color: '#374151' },

//   tipBox: {
//     background: '#eff6ff', border: '1px solid #bfdbfe',
//     borderRadius: 10, padding: '10px 14px',
//     fontSize: 12, color: '#1e40af', lineHeight: 1.6,
//   },

//   modalFooter: { display: 'flex', gap: 10, justifyContent: 'flex-end' },
//   btnCancel: {
//     padding: '10px 20px', borderRadius: 8,
//     border: '1.5px solid #e2e8f0',
//     background: '#fff', color: '#64748b',
//     fontSize: 14, fontWeight: 600, cursor: 'pointer',
//   },
//   btnSave: {
//     padding: '10px 24px', borderRadius: 8, border: 'none',
//     background: '#0f172a', color: '#fff',
//     fontSize: 14, fontWeight: 700, cursor: 'pointer',
//   },
//   btnDisabled: { opacity: 0.6, cursor: 'not-allowed' },

//   // Toast
//   toast: {
//     position: 'fixed', bottom: 24, right: 24,
//     padding: '12px 20px', borderRadius: 10,
//     fontSize: 14, fontWeight: 600,
//     boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
//     zIndex: 2000,
//     animation: 'slideUp 0.3s ease',
//   },
//   toastSuccess: { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' },
//   toastError:   { background: '#fee2e2', color: '#991b1b', border: '1px solid #fca5a5' },
//   btnPrint: {
//   background: '#eff6ff',
//   color: '#1e40af',
//   border: '1px solid #93c5fd',
//   borderRadius: 8,
//   padding: '8px 10px',
//   fontSize: 14,
//   cursor: 'pointer',
//   transition: 'all 0.2s ease',
//   boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
// },

// };

// // ─── GLOBAL CSS (animations + print) ─────────────────────────────────────────
// const globalCss = `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');

//   * { box-sizing: border-box; }

//   .qr-card:hover {
//     box-shadow: 0 8px 24px rgba(0,0,0,0.1) !important;
//     transform: translateY(-2px);
//   }

//   .qr-modal { animation: modalIn 0.25s ease; }

//   @keyframes slideUp {
//     from { transform: translateY(16px); opacity: 0; }
//     to   { transform: translateY(0);    opacity: 1; }
//   }
//   @keyframes modalIn {
//     from { transform: scale(0.95); opacity: 0; }
//     to   { transform: scale(1);    opacity: 1; }
//   }

//   .qr-spinner {
//     width: 44px; height: 44px;
//     border: 4px solid #e2e8f0;
//     border-top: 4px solid #f59e0b;
//     border-radius: 50%;
//     animation: spin 0.8s linear infinite;
//   }
//   @keyframes spin {
//     from { transform: rotate(0deg); }
//     to   { transform: rotate(360deg); }
//   }

//   /* ── Normal: hide print-only block ── */
//   .print-only { display: none; }

//   /* ── Print styles ── */
//   @media print {
//     /* Hide everything using visibility so layout is preserved */
//     * {
//       visibility: hidden !important;
//     }

//     /* Show only the print block and all its children */
//     .print-only,
//     .print-only * {
//       visibility: visible !important;
//     }

//     /* Position print block at top-left of page */
//     .print-only {
//       display: block !important;
//       position: absolute !important;
//       top: 0 !important;
//       left: 0 !important;
//       width: 100% !important;
//       background: white !important;
//       z-index: 99999 !important;
//       padding: 20px !important;
//     }

//     .print-header { text-align: center; margin-bottom: 24px; }
//     .print-header h1 { font-size: 22px; margin: 0; font-family: sans-serif; }
//     .print-header p  { font-size: 13px; color: #666; margin: 4px 0 0; }

//     .print-grid {
//       display: grid !important;
//       grid-template-columns: repeat(3, 1fr) !important;
//       gap: 20px !important;
//     }

//     .print-card {
//       border: 1.5px solid #e2e8f0 !important;
//       border-radius: 12px !important;
//       padding: 16px !important;
//       text-align: center !important;
//       page-break-inside: avoid !important;
//       background: white !important;
//     }

//     .print-floor {
//       font-size: 10px !important;
//       color: #888 !important;
//       text-transform: uppercase !important;
//       letter-spacing: 1px !important;
//       font-family: sans-serif !important;
//     }
//     .print-table {
//       font-size: 15px !important;
//       font-weight: 700 !important;
//       margin: 6px 0 10px !important;
//       font-family: sans-serif !important;
//     }
//     .print-qr {
//       width: 160px !important;
//       height: 160px !important;
//       display: block !important;
//       margin: 0 auto !important;
//     }
//     .print-url {
//       font-size: 8px !important;
//       color: #999 !important;
//       word-break: break-all !important;
//       margin-top: 8px !important;
//       font-family: monospace !important;
//     }
//   }
// html, body { overflow-x: hidden !important; }
// img { max-width: 100%; }

// /* ── Tablet & below (≤1024px) ─────────────────────── */
// @media (max-width: 1024px) {
//   .qr-card-grid {
//     grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)) !important;
//   }
//   .qr-main { padding: 16px !important; }
// }

// /* ── Tablet portrait / large phone (≤768px) ───────── */
// @media (max-width: 768px) {
//   .qr-header {
//     height: auto !important;
//     padding: 12px 16px !important;
//   }
//   .qr-header-inner {
//     flex-direction: column !important;
//     align-items: flex-start !important;
//     gap: 10px !important;
//   }
//   .qr-header-right {
//     width: 100% !important;
//     flex-wrap: wrap !important;
//     gap: 8px !important;
//   }
//   .qr-header-actions {
//     width: 100% !important;
//     margin-left: 0 !important;
//     gap: 8px !important;
//   }
//   .qr-header-actions button {
//     flex: 1 !important;
//     font-size: 12px !important;
//     padding: 8px 10px !important;
//   }

//   .qr-filter-bar {
//     flex-direction: column !important;
//     align-items: stretch !important;
//     gap: 12px !important;
//     padding: 12px 16px !important;
//   }
//   .qr-filter-group {
//     min-width: 0 !important;
//     width: 100% !important;
//   }
//   .qr-select {
//     min-width: 0 !important;
//     width: 100% !important;
//   }
//   .qr-stats-pill {
//     margin-left: 0 !important;
//     align-self: flex-start !important;
//   }

//   .qr-card-grid {
//     grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)) !important;
//     gap: 14px !important;
//   }

//   .qr-form-grid {
//     grid-template-columns: 1fr !important;
//   }

//   .qr-modal-box {
//     max-width: 92vw !important;
//     padding: 20px !important;
//     border-radius: 16px !important;
//   }
// }

// /* ── Mobile (≤480px) ───────────────────────────────── */
// @media (max-width: 480px) {
//   .qr-main { padding: 12px !important; }

//   .qr-card-grid {
//     grid-template-columns: 1fr !important;
//     gap: 12px !important;
//   }

//   .qr-wrap { padding: 8px !important; }
//   .qr-img {
//     width: 130px !important;
//     height: 130px !important;
//   }

//   .qr-card-actions {
//     flex-wrap: wrap !important;
//   }
//   .qr-card-actions button {
//     flex: 1 1 45% !important;
//     min-width: 44px !important;
//   }

//   .qr-modal-box {
//     max-width: 100vw !important;
//     width: 100% !important;
//     max-height: 100vh !important;
//     border-radius: 0 !important;
//     padding: 16px !important;
//   }
//   .qr-overlay {
//     padding: 0 !important;
//   }
//   .qr-modal-qr-wrap img {
//     width: 110px !important;
//     height: 110px !important;
//   }
//   .qr-modal-footer {
//     flex-direction: column-reverse !important;
//   }
//   .qr-modal-footer button {
//     width: 100% !important;
//   }

//   .qr-stats-pill { width: 100% !important; justify-content: center !important; }
// }

// /* ── Very small phones (≤360px) ─────────────────────── */
// @media (max-width: 360px) {
//   .qr-img { width: 110px !important; height: 110px !important; }
//   .qr-card-actions button { font-size: 11px !important; padding: 7px 8px !important; }
// }

// /* ── iPad / tablet print grid tweak ─────────────────── */
// @media print and (max-width: 1024px) {
//   .print-grid {
//     grid-template-columns: repeat(2, 1fr) !important;
//   }
// }

// `;

// import React, { useState, useEffect } from 'react';
// import QRCode from 'qrcode';

// // ─── CONFIG ──────────────────────────────────────────────────────────────────
// const API_BASE      = 'https://localhost:7095/api/Qr';
// const LIVE_BASE_URL = 'https://qrorder.selfos.in/';

// // ─── HELPERS ─────────────────────────────────────────────────────────────────
// // No table concept anymore — QR just points to the store/company.
// const buildQrUrl = (storeId, companyId) =>
//   `${LIVE_BASE_URL}?storeId=${storeId}&companyId=${companyId}`;

// const generateQRDataUrl = async (url, companyId, logoSrc = '/assets/Kadherbhai_logo.jpeg') => {
//   const qrSize = 320;
//   const scale = 3; // render at 3x then keep this resolution in the PNG — crisper logo
//   const renderSize = qrSize * scale;

//   const canvas = document.createElement('canvas');
//   await QRCode.toCanvas(canvas, url, {
//     width: renderSize,
//     margin: 2,
//     errorCorrectionLevel: 'H',
//     color: { dark: '#1a1a2e', light: '#ffffff' },
//   });

//   if (Number(companyId) !== 5) {
//     return canvas.toDataURL('image/png');
//   }

//   const ctx = canvas.getContext('2d');
//   ctx.imageSmoothingEnabled = true;
//   ctx.imageSmoothingQuality = 'high';

//   const logo = await new Promise((resolve, reject) => {
//     const img = new Image();
//     img.crossOrigin = 'anonymous';
//     img.onload = () => resolve(img);
//     img.onerror = reject;
//     img.src = logoSrc;
//   });

//   const logoSizeRatio = 0.24;
//   const logoSize = renderSize * logoSizeRatio;
//   const logoX = (renderSize - logoSize) / 2;
//   const logoY = (renderSize - logoSize) / 2;

//   const ringPadding = 3 * scale;
//   const bgSize = logoSize + ringPadding * 2;
//   const bgRadius = bgSize / 2;
//   const cx = renderSize / 2;
//   const cy = renderSize / 2;

//   ctx.save();
//   ctx.shadowColor = 'rgba(0,0,0,0.18)';
//   ctx.shadowBlur = 6 * scale;
//   ctx.fillStyle = '#ffffff';
//   ctx.beginPath();
//   ctx.arc(cx, cy, bgRadius, 0, Math.PI * 2);
//   ctx.fill();
//   ctx.restore();

//   ctx.strokeStyle = '#c8102e';
//   ctx.lineWidth = 2 * scale;
//   ctx.beginPath();
//   ctx.arc(cx, cy, bgRadius, 0, Math.PI * 2);
//   ctx.stroke();

//   ctx.save();
//   ctx.beginPath();
//   ctx.arc(cx, cy, logoSize / 2, 0, Math.PI * 2);
//   ctx.clip();

//   const drawScale = Math.max(logoSize / logo.width, logoSize / logo.height);
//   const drawW = logo.width * drawScale;
//   const drawH = logo.height * drawScale;
//   const drawX = logoX + (logoSize - drawW) / 2;
//   const drawY = logoY + (logoSize - drawH) / 2;
//   ctx.drawImage(logo, drawX, drawY, drawW, drawH);
//   ctx.restore();

//   return canvas.toDataURL('image/png');
// };

// // ─── MAIN COMPONENT ──────────────────────────────────────────────────────────
// export default function QRCodeAdmin() {
//   // Hierarchy data
//   const [companies, setCompanies] = useState([]);
//   const [stores,    setStores]    = useState([]);

//   // Selections
//   const [selCompany, setSelCompany] = useState('');
//   const [selStore,   setSelStore]   = useState('');

//   // QR state
//   const [qrImage,  setQrImage]  = useState(null);   // data URL for the single store QR
//   const [loadingQr, setLoadingQr] = useState(false);
//   const [toast,    setToast]    = useState(null);   // { type, msg }

//   // ── Toaster ────────────────────────────────────────────────────────────────
//   const showToast = (msg, type = 'success') => {
//     setToast({ msg, type });
//     setTimeout(() => setToast(null), 3500);
//   };

//   // ── 1. Load companies ──────────────────────────────────────────────────────
//   useEffect(() => {
//     fetch(`${API_BASE}/GetCompanies`)
//       .then(r => r.json())
//       .then(d => setCompanies(d.companies || []))
//       .catch(() => showToast('Failed to load companies', 'error'));
//   }, []);

//   // ── 2. Load stores when company changes ────────────────────────────────────
//   useEffect(() => {
//     setStores([]); setSelStore(''); setQrImage(null);
//     if (!selCompany) return;
//     fetch(`${API_BASE}/GetStoresByCompany?companyId=${selCompany}`)
//       .then(r => r.json())
//       .then(d => setStores(d.stores || []))
//       .catch(() => showToast('Failed to load stores', 'error'));
//   }, [selCompany]);

//   // ── 3. Generate the single QR code when store changes ──────────────────────
//   useEffect(() => {
//     setQrImage(null);
//     if (!selStore || !selCompany) return;
//     setLoadingQr(true);
//     const url = buildQrUrl(selStore, selCompany);
//     generateQRDataUrl(url, selCompany)
//       .then(setQrImage)
//       .catch(() => showToast('Failed to generate QR code', 'error'))
//       .finally(() => setLoadingQr(false));
//   }, [selStore, selCompany]);

//   const selCompanyObj = companies.find(c => c.id === +selCompany);
//   const selStoreObj   = stores.find(s => s.id === +selStore);
//   const qrUrl = (selStore && selCompany) ? buildQrUrl(selStore, selCompany) : '';

//   // ── Download ─────────────────────────────────────────────────────────────
//   const downloadQR = () => {
//     if (!qrImage) return;
//     const link = document.createElement('a');
//     link.download = `QR_${selStoreObj?.name || selStore}.png`;
//     link.href = qrImage;
//     link.click();
//   };

//   // ── Print ────────────────────────────────────────────────────────────────
//   const printQR = () => {
//     if (!qrImage) return;
//     window.print();
//   };

//   // ─────────────────────────────────────────────────────────────────────────────
//   // RENDER
//   // ─────────────────────────────────────────────────────────────────────────────
//   return (
//     <div style={css.root}>
//       <style>{globalCss}</style>

//       {/* ── Toast ── */}
//       {toast && (
//         <div style={{ ...css.toast, ...(toast.type === 'error' ? css.toastError : css.toastSuccess) }}>
//           {toast.type === 'success' ? '✓' : '✕'} {toast.msg}
//         </div>
//       )}

//       {/* ══════════════════════════ HEADER ══════════════════════════ */}
//       <header style={css.header}>
//         <div style={css.headerInner}>
//           <div style={css.logo}>
//             <span style={css.logoIcon}>⬡</span>
//             <span style={css.logoText}>QR Admin</span>
//           </div>
//           <div style={css.headerRight}>
//             {selCompanyObj && <span style={css.breadCrumb}>{selCompanyObj.name}</span>}
//             {selStoreObj   && <><span style={css.breadSep}>›</span><span style={css.breadCrumb}>{selStoreObj.name}</span></>}
//           </div>
//         </div>
//       </header>

//       {/* ══════════════════════════ FILTER BAR ══════════════════════════ */}
//       <div style={css.filterBar}>
//         <div style={css.filterGroup}>
//           <label style={css.filterLabel}>Company</label>
//           <select style={css.select} value={selCompany}
//             onChange={e => setSelCompany(e.target.value)}>
//             <option value=''>— Select Company —</option>
//             {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
//           </select>
//         </div>

//         <div style={css.filterGroup}>
//           <label style={css.filterLabel}>Store</label>
//           <select style={css.select} value={selStore}
//             onChange={e => setSelStore(e.target.value)} disabled={!selCompany}>
//             <option value=''>— Select Store —</option>
//             {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
//           </select>
//         </div>
//       </div>

//       {/* ══════════════════════════ EMPTY STATE ══════════════════════════ */}
//       {!selStore && (
//         <div style={css.emptyState}>
//           <div style={css.emptyIcon}>📋</div>
//           <div style={css.emptyTitle}>Select a Company and Store</div>
//           <div style={css.emptyDesc}>Choose from the filters above to generate the QR code for that store.</div>
//         </div>
//       )}

//       {/* ══════════════════════════ LOADING ══════════════════════════ */}
//       {loadingQr && (
//         <div style={css.loadingWrap}>
//           <div className='qr-spinner'></div>
//           <p style={css.loadingText}>Generating QR Code…</p>
//         </div>
//       )}

//       {/* ══════════════════════════ QR RESULT CARD ══════════════════════════ */}
//       {!loadingQr && qrImage && (
//         <main style={css.main}>
//           <div style={css.singleCardWrap}>
//             <div style={css.card} className='qr-card'>
//               <div style={css.storeName}>{selStoreObj?.name}</div>
//               <div style={css.storeSub}>{selCompanyObj?.name} · Store ID #{selStore}</div>

//               <div style={css.qrWrap}>
//                 <img src={qrImage} alt={`QR for ${selStoreObj?.name}`} style={css.qrImg} />
//               </div>

//               <div style={css.qrUrlText}>{qrUrl}</div>

//               <div style={css.cardActions}>
//                 <button style={css.btnDownload} onClick={downloadQR}>⬇ Download</button>
//                 <button style={css.btnOutlineDark} onClick={printQR}>🖨 Print</button>
//               </div>
//             </div>
//           </div>
//         </main>
//       )}

//       {/* ══════════════════════════ PRINT-ONLY LAYOUT ══════════════════════════ */}
//       <div className='print-only'>
//         <div className='print-header'>
//           <h1>Store QR Code</h1>
//           {selCompanyObj && <p>Company: {selCompanyObj.name}</p>}
//           {selStoreObj   && <p>Store: {selStoreObj.name}</p>}
//         </div>
//         <div className='print-card-single'>
//           {qrImage
//             ? <img src={qrImage} alt='QR' className='print-qr-single' />
//             : <div>No QR</div>
//           }
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── STYLES ───────────────────────────────────────────────────────────────────
// const css = {
//   root: {
//     fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
//     minHeight: '100vh',
//     background: '#f0f4f8',
//     color: '#1e293b',
//   },
//   header: {
//     background: '#0f172a',
//     borderBottom: '1px solid #1e293b',
//     padding: '0 24px',
//     height: 60,
//     display: 'flex',
//     alignItems: 'center',
//   },
//   headerInner: {
//     maxWidth: 1400, width: '100%', margin: '0 auto',
//     display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//   },
//   logo: { display: 'flex', alignItems: 'center', gap: 10 },
//   logoIcon: { fontSize: 22, color: '#f59e0b' },
//   logoText: { fontSize: 18, fontWeight: 700, color: '#f8fafc', letterSpacing: '-0.5px' },
//   headerRight: { display: 'flex', alignItems: 'center', gap: 10 },
//   breadCrumb: { fontSize: 13, color: '#94a3b8' },
//   breadSep: { fontSize: 13, color: '#475569', margin: '0 4px' },

//   filterBar: {
//     background: '#fff',
//     borderBottom: '1px solid #e2e8f0',
//     padding: '14px 24px',
//     display: 'flex',
//     alignItems: 'flex-end',
//     gap: 16,
//     flexWrap: 'wrap',
//   },
//   filterGroup: { display: 'flex', flexDirection: 'column', gap: 4, minWidth: 200 },
//   filterLabel: { fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.8px' },
//   select: {
//     padding: '8px 12px', borderRadius: 8,
//     border: '1.5px solid #e2e8f0',
//     fontSize: 14, color: '#1e293b',
//     background: '#fff',
//     cursor: 'pointer',
//     outline: 'none',
//     minWidth: 200,
//   },

//   emptyState: {
//     textAlign: 'center', padding: '80px 24px',
//     maxWidth: 400, margin: '0 auto',
//   },
//   emptyIcon: { fontSize: 48, marginBottom: 16 },
//   emptyTitle: { fontSize: 20, fontWeight: 700, marginBottom: 8, color: '#1e293b' },
//   emptyDesc: { fontSize: 14, color: '#64748b', lineHeight: 1.6 },
//   loadingWrap: {
//     display: 'flex', flexDirection: 'column',
//     alignItems: 'center', padding: '80px 24px',
//   },
//   loadingText: { marginTop: 16, fontSize: 14, color: '#64748b' },

//   main: { maxWidth: 1400, margin: '0 auto', padding: '24px' },
//   singleCardWrap: { display: 'flex', justifyContent: 'center' },

//   card: {
//     background: '#fff',
//     borderRadius: 16,
//     padding: '28px',
//     boxShadow: '0 1px 3px rgba(0,0,0,0.07), 0 4px 12px rgba(0,0,0,0.04)',
//     border: '1.5px solid #e2e8f0',
//     display: 'flex', flexDirection: 'column', gap: 12,
//     width: '100%', maxWidth: 360, alignItems: 'center', textAlign: 'center',
//   },
//   storeName: { fontSize: 18, fontWeight: 700, color: '#0f172a' },
//   storeSub:  { fontSize: 12, color: '#94a3b8', marginTop: -8 },

//   qrWrap: {
//     display: 'flex', justifyContent: 'center',
//     background: '#f8fafc', borderRadius: 10, padding: 14,
//   },
//   qrImg: { width: 200, height: 200, borderRadius: 6 },
//   qrUrlText: {
//     fontSize: 10, color: '#94a3b8', wordBreak: 'break-all',
//     background: '#f8fafc', padding: '6px 10px', borderRadius: 6,
//     fontFamily: 'monospace', lineHeight: 1.5, width: '100%',
//   },

//   cardActions: { display: 'flex', gap: 10, marginTop: 4, width: '100%' },
//   btnDownload: {
//     flex: 1, background: '#f59e0b', color: '#fff',
//     border: 'none', borderRadius: 8, padding: '10px 12px',
//     fontSize: 13, fontWeight: 700, cursor: 'pointer',
//   },
//   btnOutlineDark: {
//     flex: 1, background: '#fff', color: '#0f172a',
//     border: '1.5px solid #0f172a', borderRadius: 8, padding: '10px 12px',
//     fontSize: 13, fontWeight: 700, cursor: 'pointer',
//   },

//   toast: {
//     position: 'fixed', bottom: 24, right: 24,
//     padding: '12px 20px', borderRadius: 10,
//     fontSize: 14, fontWeight: 600,
//     boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
//     zIndex: 2000,
//     animation: 'slideUp 0.3s ease',
//   },
//   toastSuccess: { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' },
//   toastError:   { background: '#fee2e2', color: '#991b1b', border: '1px solid #fca5a5' },
// };

// // ─── GLOBAL CSS ────────────────────────────────────────────────────────────
// const globalCss = `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');

//   * { box-sizing: border-box; }

//   .qr-card:hover {
//     box-shadow: 0 8px 24px rgba(0,0,0,0.1) !important;
//   }

//   @keyframes slideUp {
//     from { transform: translateY(16px); opacity: 0; }
//     to   { transform: translateY(0);    opacity: 1; }
//   }

//   .qr-spinner {
//     width: 44px; height: 44px;
//     border: 4px solid #e2e8f0;
//     border-top: 4px solid #f59e0b;
//     border-radius: 50%;
//     animation: spin 0.8s linear infinite;
//   }
//   @keyframes spin {
//     from { transform: rotate(0deg); }
//     to   { transform: rotate(360deg); }
//   }

//   .print-only { display: none; }

//   @media print {
//     * { visibility: hidden !important; }

//     .print-only,
//     .print-only * {
//       visibility: visible !important;
//     }

//     .print-only {
//       display: block !important;
//       position: absolute !important;
//       top: 0 !important;
//       left: 0 !important;
//       width: 100% !important;
//       background: white !important;
//       z-index: 99999 !important;
//       padding: 20px !important;
//     }

//     .print-header { text-align: center; margin-bottom: 24px; }
//     .print-header h1 { font-size: 22px; margin: 0; font-family: sans-serif; }
//     .print-header p  { font-size: 13px; color: #666; margin: 4px 0 0; }

//     .print-card-single {
//       display: flex !important;
//       justify-content: center !important;
//       align-items: center !important;
//     }

//     .print-qr-single {
//       width: 260px !important;
//       height: 260px !important;
//       display: block !important;
//       margin: 0 auto !important;
//     }
//   }
// `;


import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

// ─── CONFIG ──────────────────────────────────────────────────────────────────
const API_BASE      = 'https://uat-ecom.azurewebsites.net/api/Sos';
const LIVE_BASE_URL = 'https://qrorder.selfos.in/';

// Company is fixed — Kadherbhai (id 5). Not user-selectable.
const FIXED_COMPANY_ID = '5';
const FIXED_COMPANY_NAME = 'Kadherbhai';

// ─── HELPERS ─────────────────────────────────────────────────────────────────
// Encode storeId + companyId into an opaque base64 token — nothing
// readable shows up in the QR content or the address bar.
const buildQrUrl = (storeId, companyId) => {
  const token = btoa(`${storeId}|${companyId}`);
  return `${LIVE_BASE_URL}?q=${encodeURIComponent(token)}`;
};

const generateQRDataUrl = async (url, companyId, logoSrc = '/assets/Kadherbhai_logo.jpeg') => {
  const qrSize = 320;
  const scale = 3; // render at 3x then keep this resolution in the PNG — crisper logo
  const renderSize = qrSize * scale;

  const canvas = document.createElement('canvas');
  await QRCode.toCanvas(canvas, url, {
    width: renderSize,
    margin: 2,
    errorCorrectionLevel: 'H',
    color: { dark: '#1a1a2e', light: '#ffffff' },
  });

  if (Number(companyId) !== 5) {
    return canvas.toDataURL('image/png');
  }

  // Try to load the logo, but never let a missing/blocked logo
  // break QR generation — just fall back to a plain QR code.
  let logo;
  try {
    logo = await new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error(`Logo failed to load: ${logoSrc}`));
      img.src = logoSrc;
    });
  } catch (err) {
    console.warn(err.message, '— returning QR without logo overlay.');
    return canvas.toDataURL('image/png');
  }

  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';

  const logoSizeRatio = 0.24;
  const logoSize = renderSize * logoSizeRatio;
  const logoX = (renderSize - logoSize) / 2;
  const logoY = (renderSize - logoSize) / 2;

  const ringPadding = 3 * scale;
  const bgSize = logoSize + ringPadding * 2;
  const bgRadius = bgSize / 2;
  const cx = renderSize / 2;
  const cy = renderSize / 2;

  ctx.save();
  ctx.shadowColor = 'rgba(0,0,0,0.18)';
  ctx.shadowBlur = 6 * scale;
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(cx, cy, bgRadius, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();

  ctx.strokeStyle = '#c8102e';
  ctx.lineWidth = 2 * scale;
  ctx.beginPath();
  ctx.arc(cx, cy, bgRadius, 0, Math.PI * 2);
  ctx.stroke();

  ctx.save();
  ctx.beginPath();
  ctx.arc(cx, cy, logoSize / 2, 0, Math.PI * 2);
  ctx.clip();

  const drawScale = Math.max(logoSize / logo.width, logoSize / logo.height);
  const drawW = logo.width * drawScale;
  const drawH = logo.height * drawScale;
  const drawX = logoX + (logoSize - drawW) / 2;
  const drawY = logoY + (logoSize - drawH) / 2;
  ctx.drawImage(logo, drawX, drawY, drawW, drawH);
  ctx.restore();

  return canvas.toDataURL('image/png');
};

// ─── MAIN COMPONENT ──────────────────────────────────────────────────────────
export default function QRCodeAdmin() {
  // Hierarchy data
  const [companies, setCompanies] = useState([]);
  const [stores,    setStores]    = useState([]);

  // Selections — company is fixed, only store is user-selectable
  const [selCompany] = useState(FIXED_COMPANY_ID);
  const [selStore,   setSelStore]   = useState('');

  // QR state
  const [qrImage,  setQrImage]  = useState(null);   // data URL for the single store QR
  const [loadingQr, setLoadingQr] = useState(false);
  const [toast,    setToast]    = useState(null);   // { type, msg }

  // ── Toaster ────────────────────────────────────────────────────────────────
  const showToast = (msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  };

  // ── 1. Load companies (used only to resolve the fixed company's display name) ─
  useEffect(() => {
    fetch(`${API_BASE}/GetCompanies`)
      .then(r => r.json())
      .then(d => setCompanies(d.companies || []))
      .catch(() => showToast('Failed to load companies', 'error'));
  }, []);

  // ── 2. Load stores for the fixed company on mount ───────────────────────────
  useEffect(() => {
    setStores([]); setSelStore(''); setQrImage(null);
    fetch(`${API_BASE}/GetStoresByCompanyQr?companyId=${FIXED_COMPANY_ID}`)
      .then(r => r.json())
      .then(d => setStores(d.stores || []))
      .catch(() => showToast('Failed to load stores', 'error'));
  }, []);

  // ── 3. Generate the single QR code when store changes ──────────────────────
  useEffect(() => {
    setQrImage(null);
    if (!selStore || !selCompany) return;
    setLoadingQr(true);
    const url = buildQrUrl(selStore, selCompany);
    generateQRDataUrl(url, selCompany)
      .then(setQrImage)
      .catch(err => showToast(`Failed to generate QR code: ${err.message}`, 'error'))
      .finally(() => setLoadingQr(false));
  }, [selStore, selCompany]);

  const selCompanyObj = companies.find(c => c.id === +selCompany) || { id: FIXED_COMPANY_ID, name: FIXED_COMPANY_NAME };
  const selStoreObj   = stores.find(s => s.id === +selStore);
  const qrUrl = (selStore && selCompany) ? buildQrUrl(selStore, selCompany) : '';

  // ── Download ─────────────────────────────────────────────────────────────
  const downloadQR = () => {
    if (!qrImage) return;
    const link = document.createElement('a');
    link.download = `QR_${selStoreObj?.name || selStore}.png`;
    link.href = qrImage;
    link.click();
  };

  // ── Print ────────────────────────────────────────────────────────────────
  const printQR = () => {
    if (!qrImage) return;
    window.print();
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div style={css.root}>
      <style>{globalCss}</style>

      {/* ── Toast ── */}
      {toast && (
        <div style={{ ...css.toast, ...(toast.type === 'error' ? css.toastError : css.toastSuccess) }}>
          {toast.type === 'success' ? '✓' : '✕'} {toast.msg}
        </div>
      )}

      {/* ══════════════════════════ HEADER ══════════════════════════ */}
      <header style={css.header}>
        <div style={css.headerInner}>
          <div style={css.logo}>
            <span style={css.logoIcon}>⬡</span>
            <span style={css.logoText}>QR Admin</span>
          </div>
          <div style={css.headerRight}>
            {selCompanyObj && <span style={css.breadCrumb}>{selCompanyObj.name}</span>}
            {selStoreObj   && <><span style={css.breadSep}>›</span><span style={css.breadCrumb}>{selStoreObj.name}</span></>}
          </div>
        </div>
      </header>

      {/* ══════════════════════════ FILTER BAR ══════════════════════════ */}
      <div style={css.filterBar}>
        <div style={css.filterGroup}>
          <label style={css.filterLabel}>Company</label>
          <div style={css.lockedField}>
            <span>{selCompanyObj?.name || FIXED_COMPANY_NAME}</span>
            {/* <span style={css.lockedBadge}>🔒 Fixed</span> */}
          </div>
        </div>

        <div style={css.filterGroup}>
          <label style={css.filterLabel}>Store</label>
          <select style={css.select} value={selStore}
            onChange={e => setSelStore(e.target.value)}>
            <option value=''>— Select Store —</option>
            {stores.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </div>
      </div>

      {/* ══════════════════════════ EMPTY STATE ══════════════════════════ */}
      {!selStore && (
        <div style={css.emptyState}>
          <div style={css.emptyIcon}>📋</div>
          <div style={css.emptyTitle}>Select a Store</div>
          <div style={css.emptyDesc}>Choose a store above to generate the QR code for it.</div>
        </div>
      )}

      {/* ══════════════════════════ LOADING ══════════════════════════ */}
      {loadingQr && (
        <div style={css.loadingWrap}>
          <div className='qr-spinner'></div>
          <p style={css.loadingText}>Generating QR Code…</p>
        </div>
      )}

      {/* ══════════════════════════ QR RESULT CARD ══════════════════════════ */}
      {!loadingQr && qrImage && (
        <main style={css.main}>
          <div style={css.singleCardWrap}>
            <div style={css.card} className='qr-card'>
              <div style={css.storeName}>{selStoreObj?.name}</div>
              <div style={css.storeSub}>{selCompanyObj?.name} · Store ID #{selStore}</div>

              <div style={css.qrWrap}>
                <img src={qrImage} alt={`QR for ${selStoreObj?.name}`} style={css.qrImg} />
              </div>

              <div style={css.qrUrlText}>{qrUrl}</div>

              <div style={css.cardActions}>
                <button style={css.btnDownload} onClick={downloadQR}>⬇ Download</button>
                <button style={css.btnOutlineDark} onClick={printQR}>🖨 Print</button>
              </div>
            </div>
          </div>
        </main>
      )}

      {/* ══════════════════════════ PRINT-ONLY LAYOUT ══════════════════════════ */}
      <div className='print-only'>
        <div className='print-header'>
          <h1>Store QR Code</h1>
          {selCompanyObj && <p>Company: {selCompanyObj.name}</p>}
          {selStoreObj   && <p>Store: {selStoreObj.name}</p>}
        </div>
        <div className='print-card-single'>
          {qrImage
            ? <img src={qrImage} alt='QR' className='print-qr-single' />
            : <div>No QR</div>
          }
        </div>
      </div>
    </div>
  );
}

// ─── STYLES ───────────────────────────────────────────────────────────────────
const css = {
  root: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    minHeight: '100vh',
    background: '#f0f4f8',
    color: '#1e293b',
  },
  header: {
    background: '#0f172a',
    borderBottom: '1px solid #1e293b',
    padding: '0 24px',
    height: 60,
    display: 'flex',
    alignItems: 'center',
  },
  headerInner: {
    maxWidth: 1400, width: '100%', margin: '0 auto',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  },
  logo: { display: 'flex', alignItems: 'center', gap: 10 },
  logoIcon: { fontSize: 22, color: '#f59e0b' },
  logoText: { fontSize: 18, fontWeight: 700, color: '#f8fafc', letterSpacing: '-0.5px' },
  headerRight: { display: 'flex', alignItems: 'center', gap: 10 },
  breadCrumb: { fontSize: 13, color: '#94a3b8' },
  breadSep: { fontSize: 13, color: '#475569', margin: '0 4px' },

  filterBar: {
    background: '#fff',
    borderBottom: '1px solid #e2e8f0',
    padding: '14px 24px',
    display: 'flex',
    alignItems: 'flex-end',
    gap: 16,
    flexWrap: 'wrap',
  },
  filterGroup: { display: 'flex', flexDirection: 'column', gap: 4, minWidth: 200 },
  filterLabel: { fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.8px' },
  select: {
    padding: '8px 12px', borderRadius: 8,
    border: '1.5px solid #e2e8f0',
    fontSize: 14, color: '#1e293b',
    background: '#fff',
    cursor: 'pointer',
    outline: 'none',
    minWidth: 200,
  },
  lockedField: {
    padding: '8px 12px', borderRadius: 8,
    border: '1.5px solid #e2e8f0',
    fontSize: 14, color: '#1e293b',
    background: '#f8fafc',
    minWidth: 200,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
  },
  lockedBadge: {
    fontSize: 10, color: '#94a3b8', fontWeight: 600,
    background: '#f1f5f9', padding: '2px 8px', borderRadius: 20,
    whiteSpace: 'nowrap',
  },

  emptyState: {
    textAlign: 'center', padding: '80px 24px',
    maxWidth: 400, margin: '0 auto',
  },
  emptyIcon: { fontSize: 48, marginBottom: 16 },
  emptyTitle: { fontSize: 20, fontWeight: 700, marginBottom: 8, color: '#1e293b' },
  emptyDesc: { fontSize: 14, color: '#64748b', lineHeight: 1.6 },
  loadingWrap: {
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', padding: '80px 24px',
  },
  loadingText: { marginTop: 16, fontSize: 14, color: '#64748b' },

  main: { maxWidth: 1400, margin: '0 auto', padding: '24px' },
  singleCardWrap: { display: 'flex', justifyContent: 'center' },

  card: {
    background: '#fff',
    borderRadius: 16,
    padding: '28px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.07), 0 4px 12px rgba(0,0,0,0.04)',
    border: '1.5px solid #e2e8f0',
    display: 'flex', flexDirection: 'column', gap: 12,
    width: '100%', maxWidth: 360, alignItems: 'center', textAlign: 'center',
  },
  storeName: { fontSize: 18, fontWeight: 700, color: '#0f172a' },
  storeSub:  { fontSize: 12, color: '#94a3b8', marginTop: -8 },

  qrWrap: {
    display: 'flex', justifyContent: 'center',
    background: '#f8fafc', borderRadius: 10, padding: 14,
  },
  qrImg: { width: 200, height: 200, borderRadius: 6 },
  qrUrlText: {
    fontSize: 10, color: '#94a3b8', wordBreak: 'break-all',
    background: '#f8fafc', padding: '6px 10px', borderRadius: 6,
    fontFamily: 'monospace', lineHeight: 1.5, width: '100%',
  },

  cardActions: { display: 'flex', gap: 10, marginTop: 4, width: '100%' },
  btnDownload: {
    flex: 1, background: '#f59e0b', color: '#fff',
    border: 'none', borderRadius: 8, padding: '10px 12px',
    fontSize: 13, fontWeight: 700, cursor: 'pointer',
  },
  btnOutlineDark: {
    flex: 1, background: '#fff', color: '#0f172a',
    border: '1.5px solid #0f172a', borderRadius: 8, padding: '10px 12px',
    fontSize: 13, fontWeight: 700, cursor: 'pointer',
  },

  toast: {
    position: 'fixed', bottom: 24, right: 24,
    padding: '12px 20px', borderRadius: 10,
    fontSize: 14, fontWeight: 600,
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    zIndex: 2000,
    animation: 'slideUp 0.3s ease',
  },
  toastSuccess: { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' },
  toastError:   { background: '#fee2e2', color: '#991b1b', border: '1px solid #fca5a5' },
};

// ─── GLOBAL CSS ────────────────────────────────────────────────────────────
const globalCss = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');

  * { box-sizing: border-box; }

  .qr-card:hover {
    box-shadow: 0 8px 24px rgba(0,0,0,0.1) !important;
  }

  @keyframes slideUp {
    from { transform: translateY(16px); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
  }

  .qr-spinner {
    width: 44px; height: 44px;
    border: 4px solid #e2e8f0;
    border-top: 4px solid #f59e0b;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
  @keyframes spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }

  .print-only { display: none; }

  @media print {
    * { visibility: hidden !important; }

    .print-only,
    .print-only * {
      visibility: visible !important;
    }

    .print-only {
      display: block !important;
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      background: white !important;
      z-index: 99999 !important;
      padding: 20px !important;
    }

    .print-header { text-align: center; margin-bottom: 24px; }
    .print-header h1 { font-size: 22px; margin: 0; font-family: sans-serif; }
    .print-header p  { font-size: 13px; color: #666; margin: 4px 0 0; }

    .print-card-single {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }

    .print-qr-single {
      width: 260px !important;
      height: 260px !important;
      display: block !important;
      margin: 0 auto !important;
    }
  }
`;